import { render, staticRenderFns } from "./AuthBrandFooter.vue?vue&type=template&id=ec9dc3d4&scoped=true"
import script from "./AuthBrandFooter.vue?vue&type=script&lang=js"
export * from "./AuthBrandFooter.vue?vue&type=script&lang=js"
import style0 from "./AuthBrandFooter.vue?vue&type=style&index=0&id=ec9dc3d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec9dc3d4",
  null
  
)

export default component.exports